var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitboi1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 674.441,
    height: 684.722,
    viewBox: "0 0 674.441 684.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.829,
    y1: 0.53,
    x2: 0.705,
    y2: 0.457,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302624",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#302624",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#302624",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.523,
    y1: 0.157,
    x2: 0.466,
    y2: 0.798,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.377,
    y1: 0.178,
    x2: -0.386,
    y2: 1.011,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#cfd4d8",
    stopOpacity: 0.631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#cfd4d8",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#cfd4d8",
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4d8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.999, 0.045, -0.045, 0.999, 679.554, 15.445)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69d7d",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#f69d7d",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#f69d7d",
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#f69d7d",
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69d7d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.999, 0.045, -0.045, 0.999, 688.598, 15.65)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 602.714,
    y1: 0.601,
    x2: 602.012,
    y2: 0.404,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#f69d7d",
    stopOpacity: 0.929
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#f69d7d",
    stopOpacity: 0.745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69d7d",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.453,
    y1: 1.176,
    x2: 0.516,
    y2: 0.309,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e8d8",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#f8e8d8",
    stopOpacity: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8e8d8",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(-406.422 -43.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M575.51,200.642s-7.34-12.263-13.706-16.7-16.515-3.564-24.417-11.934-20.193-.123-20.414-15.978S524,144.42,515.658,136.9s7.475-20.235,7.475-20.235S481.162,98.1,485.33,89.645s36.11,11.132,77.321,16.691c0,0,16.437-8.267,20.683-2.968s.3,52.664.3,52.664l16.679,29.338Z",
    transform: "translate(-78.617 255.843)",
    fill: "#fbc0a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M530.332,112.117l-9.1-14.025s-28.415,15.258-36.189,36.439l14.211,9.322Z",
    transform: "translate(-8.637 317.519)",
    fill: "#f8e8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M517.3,90.3c-15.171,12.757-25.769,29.3-21.786,33.259s21.786-8.534,21.786-8.534l-2,14.271s-18.116,9.473-24.2-4.085S517.3,90.3,517.3,90.3Z",
    transform: "translate(-33.267 271.882)",
    fill: "#f69d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M657.729,91.1c-5.555,11.632-57.9,135.523-57.9,135.523s-14.951-15.889-13.749,0l-83.843-82.914s-38.657,12.647-41.751,45.5c0,0,104.178,138.052,141.981,141.795s72.1-98.782,72.1-98.782Z",
    transform: "translate(21.787 276.595)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M657.729,91.1c-5.555,11.632-57.9,135.523-57.9,135.523s-14.951-15.889-13.749,0l-83.843-82.914s-38.657,12.647-41.751,45.5c0,0,104.178,138.052,141.981,141.795s72.1-98.782,72.1-98.782Z",
    transform: "translate(21.787 276.595)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M443.429,157.879s-10.256-.542-14.659-5.737,10.014-47.763,10.014-47.763-13.7-11.406-13.9-27.412,10.8-24.259,27.91-23.244S494.6,76.666,494.6,76.666L482.051,82.9s-4.047,36.3-9.4,45.624S443.429,157.879,443.429,157.879Z",
    transform: "translate(455.004 57.268)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M463.855,64.974c-5.022,22.668-21.637,78.643-21.637,78.643l-14.78-16.232,7.419-69.972Z",
    transform: "translate(467.531 79.358)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M696.638,123.292,662.277,244.941,679.745,358.6s-155.175,56.839-252.553-4.4l20-253.985Z",
    transform: "translate(236.498 329.93)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(673.654 328.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M457.5,103.11c-20.8,8.438-50,25.335-24.346,83.709l8.927,179.653s-9.958,27.686-3.677,33.56C486.725,445.2,550.127,445.2,637.7,410.753c0,0,4.609-5.662,5.206-7.938,3.208-12.208-7.489-46.289-7.489-46.289L684.354,209.9s48.245-63.282,16.3-86.231C650.406,87.564,539.8,69.721,457.5,103.11Z",
    transform: "translate(-423.117 -85.419)",
    fill: "#3e3533"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M426.374,348.793l11.608-147.4a289.189,289.189,0,0,1,52.74,86.293,369.357,369.357,0,0,0,130.857-109.27L583.3,277.038c33.095-37.426,85.251-138.484,118.339-175.9l-40.179,138.4,17.469,113.657S523.752,410.032,426.374,348.793Z",
    transform: "translate(237.316 335.334)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M471.185,84.953s-19.311-.8-22.817,1.289-12.3,26.527-14.061,30.387,23.471,26.6,23.471,26.6-20.826,32.95-19.951,35.61,37.8,146.7,37.8,146.7S565.17,196.828,567,190.432s-8.578-39.51-8.578-39.51,26.516-18.83,28.13-22.942,5-30.359,0-33.691c-3.08-2.05-20.9-5.916-20.9-5.916Z",
    transform: "translate(293.988 239.71)",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M535.075,94.631h0c0,.007-27.447,68.258-51.616,128.367-19.012,47.283-40.008-2.18-40.008-2.18l-5.925-135.53c1.316-.089,4.061-.425,5.37-.493Z",
    transform: "translate(324.559 239.67)",
    fill: "#f8e8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M445.031,128.576c-5.491-1.254-5.747-17.836-5.747-17.836l-1.1-25.088.178-.377c1.373-.1,3.926-.411,5.178-.48l84.952,9.069c-.306.973,3.1,7.8,2.489,9.713-4.922,13.963-20.783,34.04-23.962,34.534-3.734.569-13.236-9.919-14.51-13.346-1.956,1.693-5.3,6.772-7.248,8.472-1.039,24.4-.121,56.51.284,86.176-14.716,36.6-28.45,70.74-34.368,85.47-1.074,1.371-2.155,2.666-3.236,3.921l-3.172-72.522q14.371-52.376,28.749-104.746c-3.044-4.01-6.977-7-10.022-11.015C458.417,125.285,452.115,128.569,445.031,128.576Z",
    transform: "translate(323.918 239.67)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(788.601 237.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M434.587,172.75c8.243,4.586,25.271,6.985,34.525,7.2,13.748.363,8.222-7.389,12.81-8.568l44.6-99.248-80.685,35.041-.185,3.3Z",
    transform: "translate(-434.587 -72.131)",
    fill: "#fbc0a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(793.822 237.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M451.536,141.87a83.117,83.117,0,0,0,24.773-6.964,170.791,170.791,0,0,0,21.992-11.6l23-51.177-80.685,35.041-.185,3.3-5.846,32.909C440.227,142.837,445.9,142.508,451.536,141.87Z",
    transform: "translate(-434.587 -72.131)",
    fill: "#f69d7d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M442.843,206.785l28.72-93.422L459,99.77l21.331-12.578,16.316,14.5-15.185,12.962a836.265,836.265,0,0,1,1.394,94.306c-19.019,47.283-36,89.528-36,89.528Z",
    transform: "translate(325.167 253.703)",
    fill: "#c467a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(759.719 308.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M524.382,85.37S491.942,115.3,483.627,114s-12.66-31.476-12.66-31.476-29.631,8.212-33.252,12.194,5.228,43.068,9.14,44.966c8.2,3.989,32.91-22.6,37.412-19.207s17.227,26.1,21.43,25.643,37.6-32.21,35.719-43.89S524.382,85.37,524.382,85.37Z",
    transform: "translate(-436.863 -82.525)",
    fill: "#f8e8d8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M586.086,140.815s27.86-6.128,24,25.938-27.952,32.7-35.058,34.081c0,0-13.258,57.1-86.347,51.629s-61.1-60.005-60.564-96.17S424.467,57.325,472.306,52.7C520.565,48.03,590.318,51.094,586.086,140.815Z",
    transform: "translate(323.493 44.001)",
    fill: "#fbc0a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(785.393 234.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M487.346,71.657a79.113,79.113,0,0,1-45.94,9.884c4.545,11.564,9.353,19.536,27.014,16.821C482.886,96.142,490.5,83.8,487.346,71.657Z",
    transform: "translate(-441.406 -71.657)",
    fill: "#cb4453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M477.481,72.45c.953,10.1-7.027,20.338-19.332,22.23a30.043,30.043,0,0,1-12.9-1.186q-1.931-5.881-3.855-11.763,16.569-4.421,33.145-8.836A10.741,10.741,0,0,1,477.481,72.45Z",
    transform: "translate(-430.865 -67.028)",
    fill: "#f8e8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M475.475,73.07c-4.211,4.805-10.178,7.972-16.43,9.761A68.63,68.63,0,0,1,443.262,85.1c-.5-1.549-1.017-3.1-1.522-4.647q14.606-3.9,29.211-7.787Z",
    transform: "translate(-431.206 -65.75)",
    fill: "#cfd4d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M441.4,81.87a33.085,33.085,0,0,0,2.2,5.292c.711.946,21.388,2.735,38.863-8.746a17.953,17.953,0,0,0-.661-6.759C471.581,77.566,453.5,81.816,441.4,81.87Z",
    transform: "translate(-435.869 -71.657)",
    fill: "#f8e8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(794.959 198.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M453.223,103.51c.057-.679-2.333-1.3-3.592-4.291a8.388,8.388,0,0,1-.455-5.36,31.937,31.937,0,0,1,2.774-7.108c5.1-10.68,8.229-19.8,6.985-20.345s-6.4,7.657-11.509,18.343a26,26,0,0,0-2.8,8.507,12.031,12.031,0,0,0,.292,4.284,10.063,10.063,0,0,0,1.679,3.407,7.431,7.431,0,0,0,4.581,3.016C452.512,104.161,453.209,103.811,453.223,103.51Z",
    transform: "translate(-444.56 -66.379)",
    fill: "#f69d7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(824.845 170.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M437.38,69.539c.413.569,2.482-.226,5.733-1.062a34.607,34.607,0,0,1,24.93,2.3c1.522.733,2.753,1.33,3.634,1.755.917.418,1.544.59,1.785.343s.092-.836-.462-1.707a14.64,14.64,0,0,0-3.016-3.222,26.3,26.3,0,0,0-28.223-2.6C438.44,67.16,437,69.038,437.38,69.539Z",
    transform: "translate(-437.321 -62.403)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(760.53 166.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M482.495,72.209c.47-.425-.569-2.523-3.471-4.922a25.727,25.727,0,0,0-13.642-5.429A26.058,26.058,0,0,0,450.8,64.675a15.287,15.287,0,0,0-3.592,2.6c-.718.761-.967,1.323-.789,1.6s.832.233,1.814-.014c.953-.254,2.283-.61,3.919-1.049a37.139,37.139,0,0,1,12.639-1.186,36.712,36.712,0,0,1,12.283,3.489C480.105,71.537,481.976,72.7,482.495,72.209Z",
    transform: "translate(-446.365 -61.744)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M434.98,87.545c-.491,10.419,7.874,19.255,18.692,19.728s19.986-7.588,20.477-18.014S466.275,70,455.457,69.524,435.47,77.119,434.98,87.545Z",
    transform: "translate(403.723 150.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M447.447,86.971c-.491,10.426,7.881,19.261,18.692,19.734s19.987-7.595,20.477-18.014-7.874-19.261-18.692-19.734S447.937,76.545,447.447,86.971Z",
    transform: "translate(302.583 146.828)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M446.545,74.139A9.824,9.824,0,1,0,456.8,65.119,9.607,9.607,0,0,0,446.545,74.139Z",
    transform: "translate(329.389 124.413)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M448.362,72.616c2.546,8.486-1.067,17.431-4.616,25.575-1.053,2.42-2.219,4.97-4.467,6.45s-5.918,1.261-7.1-1.1c-1.145-2.289.541-4.867,1.863-7.067s2.063-5.491-.149-6.868c-1.031-.638-2.382-.583-3.471-1.138-2.354-1.2-2.34-4.442-1.735-6.951a38.19,38.19,0,0,1,3.962-9.925c1.757-3.057,4.517-6.176,8.137-6.121C444.578,65.528,447.309,69.106,448.362,72.616Z",
    transform: "translate(475.705 126.505)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(868.532 120.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M470.316,119.011s-11.458,8.123-14.609,26.082h-8.421V114.068s-25.5-6.759-15.826-42.862,47.633-.24,47.633-.24Z",
    transform: "translate(-429.27 -55.098)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M512.279,156.254c-4.424-8.925-9.19-17.678-14.474-26.178-3.25,2.372-6.38,4.647-9.175,6.676-9.858,7.156-16.608,11.968-17.924,12.654-6.2,3.331-31.231,2.324-32.561,18.3,0,0-7.2,7.883-13.258,15.416-6.053,7.513,16.316,8.417,16.487,17.623s16.288,4.887,18.642,14.223c2.376,9.363,2.781,8.568,10.9,8.829,8.087.254,16.217-5.621,17.475-18.857,0,0,16.8-.473,20.556-14.827.114-.459.206-.912.277-1.35C511.034,177.421,499.6,165.514,512.279,156.254Z",
    transform: "translate(444.641 504.773)",
    fill: "#fbc0a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M462.2,163.752l-9.716,9.884s-20.178-10.775-30.733-32.361L432.6,128.163Z",
    transform: "translate(509.635 493.573)",
    fill: "#f8e8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M453.9,389.244c-21.907-12.736-41.331-43.177-41.331-43.177l58.92-86.464-65.066-80.5,24.2-88.1c39.1,31.333,127.024,146.065,129.662,176.726C561.227,278.665,453.9,389.244,453.9,389.244Z",
    transform: "translate(520.568 275.992)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M534.743,127.847s27.206,18.926,61.317,4.037,33.948-36.871,33.948-36.871-29.844-1.145-50.1-22.805S500.625,28.564,456.1,58.327s-30.527,73.447-3.855,80.816,41.772-10.474,48.522-6.532S518.15,140.809,534.743,127.847Z",
    transform: "translate(302.074 0)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M426.646,56.2a72.549,72.549,0,0,1,9.787-9.507c51.58,32.21,113.581,48.778,175.012,46.831a44.632,44.632,0,0,1-4.09,5.258A108.857,108.857,0,0,1,622,107.538a217.486,217.486,0,0,1-77.4,4.065A214.343,214.343,0,0,1,426.646,56.2Z",
    transform: "translate(315.019 16.614)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(822.659 193.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M438.322,73.785c.477.535,2.248-.24,4.979-1.158a43.026,43.026,0,0,1,4.822-1.323,41.122,41.122,0,0,1,6-.733,40.4,40.4,0,0,1,6.039.3,42.657,42.657,0,0,1,4.915.967c2.7.665,4.694,1.405,5.057.8.313-.528-.69-2.146-3.649-3.9a20.852,20.852,0,0,0-5.4-2.193,25.208,25.208,0,0,0-14.225.514,20.871,20.871,0,0,0-5.213,2.577C438.94,71.529,437.9,73.325,438.322,73.785Z",
    transform: "translate(-438.232 -65.76)",
    fill: "#3e3533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitboi1);
export default __webpack_public_path__ + "static/media/Suitboi1.6ae32fbf6250b062f08cfac2e24fb1ee.svg";
export { ForwardRef as ReactComponent };